module.exports = __webpack_public_path__ + "assets/img/thumb-ICI-UK-Content-Marketing.818b5011.webp";